import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/email-templates/new/loading';

export const Route = createFileRoute('/_private/settings/email-templates/new')({
  component: Loading,
});
